import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "mx-6" }, null, -1)
const _hoisted_2 = { class: "mt-4 my-2 w-full flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddClinic = _resolveComponent("AddClinic")!
  const _component_AddManager = _resolveComponent("AddManager")!
  const _component_ClinicsList = _resolveComponent("ClinicsList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.userState.admin)
        ? (_openBlock(), _createBlock(_component_AddClinic, {
            key: 0,
            class: "mx-4"
          }))
        : _createCommentVNode("", true),
      (_ctx.userState.admin)
        ? (_openBlock(), _createBlock(_component_AddManager, {
            key: 1,
            class: "mr-6"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ClinicsList, { class: "px-6 pt-2 pb-8" })
  ]))
}